import theme from '@styles/theme';

export const EQUIPMENT_DATA = [
    {
        id: 1,
        order: 1,
        deviceName: '신형(DID) 스탠드 / 셋톱박스',
        location: '로비',
        version: '1.0',
        installedAt: '2025-06-12',
        duration: 48
    },
    {
        id: 2,
        order: 2,
        deviceName: '신형(DID) 스탠드 / 셋톱박스',
        location: '로비',
        version: '1.0',
        installedAt: '2025-06-12',
        duration: 48
    },
    {
        id: 3,
        order: 3,
        deviceName: '신형(DID) 스탠드 / 셋톱박스',
        location: '로비',
        version: '1.0',
        installedAt: '2025-06-12',
        duration: 48
    }
];

export const DID_DATA = {
    id: 1,
    hmVersion: 1,
    type: 'free',
    bgColor: theme.colors.ultraLightGrayBorder,
    pointColor: theme.colors.positiveBlue
};
export const PLAYLIST_DATA = [
    {
        id: 1,
        img: 'https://picsum.photos',
        filename: 'dental1.png',
        type: '배너이미지',
        filesize: 28.2,
        notice: ''
    },
    {
        id: 2,
        img: 'https://picsum.photos',
        filename: 'dental2.png',
        type: '배너이미지',
        filesize: 28.2,
        notice: ''
    },
    {
        id: 3,
        img: 'https://picsum.photos',
        filename: 'dental3.png',
        type: '배너영상',
        filesize: 28.2,
        notice: ''
    },
    {
        id: 4,
        img: 'https://picsum.photos',
        filename: 'dental4.png',
        type: '배너이미지',
        filesize: 28.2,
        notice: ''
    }
];
export const LOG_DATA = [
    {
        id: 1,
        createdAt: '2025-06-10 13:45',
        title: '네트워크 연결 끊김',
        time: 2
    },
    {
        id: 2,
        createdAt: '2025-06-10 13:45',
        title: '네트워크 연결 끊김',
        time: 2
    },
    {
        id: 3,
        createdAt: '2025-06-09 13:45',
        title: '플레이리스트 송출 실패',
        time: 2
    },
    {
        id: 4,
        createdAt: '2025-06-08 13:45',
        title: '플레이리스트 송출 실패',
        time: 2
    }
];
export const NOTICE_DATA = [
    {
        id: 5,
        img: 'https://picsum.photos/68/36',
        filename: '',
        type: '텍스트',
        filesize: '',
        notice: '1이지스병원 외래진료 휴진안내입니다. 다가오는 2025년 3월 1일(토)-삼일절 , 2025년 3월3일(일)-임시공휴일에는 휴진이오니 외래진료예약 및 진료에 착오없으시기 바랍니다.'
    },
    {
        id: 6,
        img: 'https://picsum.photos/68/36',
        filename: '',
        type: '텍스트',
        filesize: '',
        notice: '2이지스병원 외래진료 휴진안내입니다. 다가오는 2025년 3월 1일(토)-삼일절 , 2025년 3월3일(일)-임시공휴일에는 휴진이오니 외래진료예약 및 진료에 착오없으시기 바랍니다.'
    },
    {
        id: 7,
        img: 'https://picsum.photos/68/36',
        filename: '',
        type: '텍스트',
        filesize: '',
        notice: '3이지스병원 외래진료 휴진안내입니다. 다가오는 2025년 3월 1일(토)-삼일절 , 2025년 3월3일(일)-임시공휴일에는 휴진이오니 외래진료예약 및 진료에 착오없으시기 바랍니다.'
    },
    {
        id: 8,
        img: 'https://picsum.photos/68/36',
        filename: '',
        type: '텍스트',
        filesize: '',
        notice: '4이지스병원 외래진료 휴진안내입니다. 다가오는 2025년 3월 1일(토)-삼일절 , 2025년 3월3일(일)-임시공휴일에는 휴진이오니 외래진료예약 및 진료에 착오없으시기 바랍니다.'
    }
];

export const AGREEMENT_DATA =
    '<p>법관이 중대한 심신상의 장해로 직무를 수행할 수 없을 때에는 법률이 정하는 바에 의하여 퇴직하게 할 수 있다. 대통령의 임기연장 또는 중임변경을 위한 헌법개정은 그 헌법개정 제안 당시의 대통령에 대하여는 효력이 없다. 제2항의 재판관중 3인은 국회에서 선출하는 자를, 3인은 대법원장이 지명하는 자를 임명한다.</p><p>모든 국민은 그 보호하는 자녀에게 적어도 초등교육과 법률이 정하는 교육을 받게 할 의무를 진다. 국무총리는 국회의 동의를 얻어 대통령이 임명한다. 법률안에 이의가 있을 때에는 대통령은 제1항의 기간내에 이의서를 붙여 국회로 환부하고, 그 재의를 요구할 수 있다. 국회의 폐회중에도 또한 같다. 모든 국민은 법률이 정하는 바에 의하여 납세의 의무를 진다.</p><p>모든 국민은 신속한 재판을 받을 권리를 가진다. 형사피고인은 상당한 이유가 없는 한 지체없이 공개재판을 받을 권리를 가진다. 국회는 국민의 보통·평등·직접·비밀선거에 의하여 선출된 국회의원으로 구성한다. 국가안전보장에 관련되는 대외정책·군사정책과 국내정책의 수립에 관하여 국무회의의 심의에 앞서 대통령의 자문에 응하기 위하여 국가안전보장회의를 둔다.</p><p>대법원장과 대법관이 아닌 법관은 대법관회의의 동의를 얻어 대법원장이 임명한다. 국회의원과 정부는 법률안을 제출할 수 있다. 평화통일정책의 수립에 관한 대통령의 자문에 응하기 위하여 민주평화통일자문회의를 둘 수 있다. 피고인의 자백이 고문·폭행·협박·구속의 부당한 장기화 또는 기망 기타의 방법에 의하여 자의로 진술된 것이 아니라고 인정될 때 또는 정식재판에 있어서 피고인의 자백이 그에게 불리한 유일한 증거일 때에는 이를 유죄의 증거로 삼거나 이를 이유로 처벌할 수 없다.</p><p>국회의원의 수는 법률로 정하되, 200인 이상으로 한다. 국가안전보장회의는 대통령이 주재한다. 공개하지 아니한 회의내용의 공표에 관하여는 법률이 정하는 바에 의한다. 여자의 근로는 특별한 보호를 받으며, 고용·임금 및 근로조건에 있어서 부당한 차별을 받지 아니한다. 모든 국민은 양심의 자유를 가진다.</p><p>대법원은 법률에 저촉되지 아니하는 범위안에서 소송에 관한 절차, 법원의 내부규율과 사무처리에 관한 규칙을 제정할 수 있다. 대통령으로 선거될 수 있는 자는 국회의원의 피선거권이 있고 선거일 현재 40세에 달하여야 한다. 대한민국의 국민이 되는 요건은 법률로 정한다. 대통령은 국가의 원수이며, 외국에 대하여 국가를 대표한다.</p><p>이 헌법시행 당시의 대법원장과 대법원판사가 아닌 법관은 제1항 단서의 규정에 불구하고 이 헌법에 의하여 임명된 것으로 본다. 국가는 노인과 청소년의 복지향상을 위한 정책을 실시할 의무를 진다. 국회는 국가의 예산안을 심의·확정한다. 통신·방송의 시설기준과 신문의 기능을 보장하기 위하여 필요한 사항은 법률로 정한다.</p><p>선거운동은 각급 선거관리위원회의 관리하에 법률이 정하는 범위안에서 하되, 균등한 기회가 보장되어야 한다. 모든 국민은 소급입법에 의하여 참정권의 제한을 받거나 재산권을 박탈당하지 아니한다. 공무원인 근로자는 법률이 정하는 자에 한하여 단결권·단체교섭권 및 단체행동권을 가진다. 국회는 국무총리 또는 국무위원의 해임을 대통령에게 건의할 수 있다.</p>';

export const FAQ_DATA = [
    { id: 1, category: '서비스 일반 문의', title: '헬로미디어 서비스란?' },
    {
        id: 2,
        category: '서비스 일반 문의',
        title: '이용 연령 등 서비스 이용에 제한이 있나요?'
    },
    {
        id: 3,
        category: '서비스 일반 문의',
        title: '서비스 관련 이용 문의는 어디로 하면 되나요?'
    },
    {
        id: 4,
        category: '서비스 일반 문의',
        title: '서비스 이용 중 오류가 발생하면 어떻게 해야 하나요?'
    },
    {
        id: 5,
        category: '서비스 일반 문의',
        title: '제공되는 서비스는 어떤 것들이 있나요?'
    },
    {
        id: 6,
        category: '서비스 일반 문의',
        title: '결제 방법은 어떤 것이 있나요?'
    },
    {
        id: 7,
        category: '서비스 일반 문의',
        title: '서비스 이용 종료 시 절차는 어떻게 되나요?'
    },
    {
        id: 8,
        category: '서비스 일반 문의',
        title: '고객 지원은 언제 이용할 수 있나요?'
    },
    {
        id: 9,
        category: '구독 관련 서비스 이용',
        title: '구독 관련 서비스 이용'
    },
    {
        id: 10,
        category: '구독 관련 서비스 이용',
        title: '구독 관련 서비스 이용'
    },
    {
        id: 11,
        category: '구독 관련 서비스 이용',
        title: '구독 관련 서비스 이용'
    },
    {
        id: 12,
        category: '구독 관련 서비스 이용',
        title: '구독 관련 서비스 이용'
    }
];

export const NOTICE_LIST_DATA = [
    {
        id: 1,
        createdAt: '2025-03-31',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: true
    },
    {
        id: 2,
        createdAt: '2025-03-31',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    },
    {
        id: 3,
        createdAt: '2025-03-28',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    },
    {
        id: 4,
        createdAt: '2025-03-28',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    },
    {
        id: 5,
        createdAt: '2025-03-28',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    },
    {
        id: 6,
        createdAt: '2025-03-28',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    },
    {
        id: 7,
        createdAt: '2025-03-28',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    },
    {
        id: 8,
        createdAt: '2025-03-28',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: true
    },
    {
        id: 9,
        createdAt: '2025-03-26',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    },
    {
        id: 10,
        createdAt: '2025-03-26',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    },
    {
        id: 11,
        createdAt: '2025-03-26',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    },
    {
        id: 12,
        createdAt: '2025-03-26',
        title: '[개인정보처리방침 변경] 개인정보 처리방침 및 약관 변경',
        important: false
    }
];
export const ADVERTISEMENT_DATA = [
    {
        id: 1,
        img: 'https://picsum.photos/39/22',
        title: '(최종)보건의료인력 인권침배 방지 캠페인',
        status: 1,
        fileDuration: 15,
        startedAt: '2025-03-26',
        endAt: '2025-06-26'
    },
    {
        id: 2,
        img: 'https://picsum.photos/39/22',
        title: '(최종)보건의료인력 인권침배 방지 캠페인',
        status: 1,
        fileDuration: 15,
        startedAt: '2025-03-26',
        endAt: '2025-06-26'
    },
    {
        id: 3,
        img: 'https://picsum.photos/39/22',
        title: '(최종)보건의료인력 인권침배 방지 캠페인',
        status: 2,
        fileDuration: 15,
        startedAt: '2025-03-26',
        endAt: '2025-06-26'
    },
    {
        id: 4,
        img: 'https://picsum.photos/39/22',
        title: '(최종)보건의료인력 인권침배 방지 캠페인',
        status: 3,
        fileDuration: 15,
        startedAt: '2025-03-26',
        endAt: '2025-06-26'
    }
];
export const DEVICE_OP_DATA = [
    { name: '2025-04-01', value1: 30, value3: 10, value2: 1 },
    { name: '2025-04-02', value1: 10, value3: 30, value2: 5 },
    { name: '2025-04-03', value1: 2, value3: 10, value2: 5 },
    { name: '2025-04-04', value1: 22, value3: 10, value2: 3 },
    { name: '2025-04-05', value1: 50, value3: 20, value2: 5 },
    { name: '2025-04-06', value1: 75, value3: 15, value2: 9 },
    { name: '2025-04-07', value1: 12, value3: 10, value2: 5 },
    { name: '2025-04-08', value1: 50, value3: 40, value2: 6 },
    { name: '2025-04-09', value1: 75, value3: 10, value2: 5 },
    { name: '2025-04-10', value1: 12, value3: 15, value2: 5 },
    { name: '2025-04-11', value1: 30, value3: 10, value2: 1 },
    { name: '2025-04-12', value1: 10, value3: 30, value2: 5 },
    { name: '2025-04-13', value1: 2, value3: 10, value2: 5 },
    { name: '2025-04-14', value1: 22, value3: 10, value2: 3 },
    { name: '2025-04-15', value1: 50, value3: 20, value2: 5 },
    { name: '2025-04-16', value1: 75, value3: 15, value2: 9 },
    { name: '2025-04-17', value1: 12, value3: 10, value2: 5 },
    { name: '2025-04-18', value1: 50, value3: 40, value2: 6 },
    { name: '2025-04-19', value1: 75, value3: 10, value2: 5 },
    { name: '2025-04-20', value1: 12, value3: 15, value2: 5 },
    { name: '2025-04-21', value1: 30, value3: 10, value2: 1 },
    { name: '2025-04-22', value1: 10, value3: 30, value2: 5 },
    { name: '2025-04-23', value1: 2, value3: 10, value2: 5 },
    { name: '2025-04-24', value1: 22, value3: 10, value2: 3 },
    { name: '2025-04-25', value1: 50, value3: 20, value2: 5 },
    { name: '2025-04-26', value1: 75, value3: 15, value2: 9 },
    { name: '2025-04-27', value1: 12, value3: 10, value2: 5 },
    { name: '2025-04-28', value1: 50, value3: 40, value2: 6 },
    { name: '2025-04-29', value1: 75, value3: 10, value2: 5 },
    { name: '2025-04-30', value1: 12, value3: 15, value2: 5 }
];
export const HITMAP_DATA = [
    { name: '2025-04-01', value: 14, value1: 20 },
    { name: '2025-04-02', value: 12, value1: 16 },
    { name: '2025-04-03', value: 15, value1: 17 },
    { name: '2025-04-04', value: 15, value1: 19 },
    { name: '2025-04-05', value: 9, value1: 12 },
    { name: '2025-04-06', value: 14, value1: 17 },
    { name: '2025-04-07', value: 10, value1: 13 },
    { name: '2025-04-08', value: 12, value1: 18 },
    { name: '2025-04-09', value: 10, value1: 14 },
    { name: '2025-04-10', value: 14, value1: 16 },
    { name: '2025-04-11', value: 14, value1: 20 },
    { name: '2025-04-12', value: 12, value1: 16 },
    { name: '2025-04-13', value: 15, value1: 17 },
    { name: '2025-04-14', value: 15, value1: 19 },
    { name: '2025-04-15', value: 9, value1: 12 },
    { name: '2025-04-16', value: 14, value1: 17 },
    { name: '2025-04-17', value: 10, value1: 13 },
    { name: '2025-04-18', value: 12, value1: 18 },
    { name: '2025-04-19', value: 10, value1: 14 },
    { name: '2025-04-20', value: 14, value1: 16 },
    { name: '2025-04-21', value: 14, value1: 20 },
    { name: '2025-04-22', value: 12, value1: 16 },
    { name: '2025-04-23', value: 15, value1: 17 },
    { name: '2025-04-24', value: 15, value1: 19 },
    { name: '2025-04-25', value: 9, value1: 12 },
    { name: '2025-04-26', value: 14, value1: 17 },
    { name: '2025-04-27', value: 10, value1: 13 },
    { name: '2025-04-28', value: 12, value1: 18 },
    { name: '2025-04-29', value: 10, value1: 14 },
    { name: '2025-04-30', value: 14, value1: 16 }
];
export const PROFILE_DATA = {
    email: 'hong@platcube.com',
    username: '홍길동',
    license: '88888888',
    hospitalName: '참좋은내과',
    phoneNum1: '010',
    phoneNum2: '1234',
    phoneNum3: '0000',
    faxNum1: '',
    faxNum2: '',
    faxNum3: '',
    exponentNum1: '',
    exponentNum2: '',
    exponentNum3: '',
    address: '서울특별시 성동구 성수일로 111',
    zipcode: '04791',
    addressDetail: '11층 1112호',
    chart: '이지스'
};

export const PATIENT_CHART_DATA = [
    ['박*동', '최*영', '김*순', '이*동'],
    ['이*협', '여*원', '서*동', '최*욱'],
    ['김*환', '길*영', '강*한', '이*욱']
];
